import styles from "./TextArea.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";

export function TextArea({ children, ...props }) {
  return (
    <textarea
      className={classNames(styles.textarea, props.className)}
      {...props}
    >
      {children}
    </textarea>
  );
}

TextArea.propTypes = {};
